import { StorageCreate } from "@/modules/storage/StorageCreate.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/storage/create")({
    component: StorageCreate,
});
